<template>
  <div>
    <content-panel class="panel-tabs">
      <el-tabs v-model="activeName" class="tabs">
        <el-tab-pane :label="item.label" v-for="item in tables" :key="item.value" :name="item.value">
          <div slot="label">
            <span>{{ item.label }}</span>
            <el-badge :value="item.number" v-if="item.number"></el-badge>
          </div>
        </el-tab-pane>
      </el-tabs>
      <component :is="activeComponent" @getNumber="getNumber" :isInformationNotMaintained="isInformationNotMaintained" :isTextNotMaintained="isTextNotMaintained"></component>
    </content-panel>
  </div>
</template>

<script>
import InformationNotMaintained from './information-not-maintained/InformationNotMaintained';
import TextNotMaintained from './text-not-maintained/TextNotMaintained';
import PriceMotMaintained from './price-not-maintained/PriceMotMaintained';
import Completed from './completed/Completed';
import pagePathMixin from '@/utils/page-path-mixin';
export default {
  name: 'QualityInspectionAnalysis',
  mixins: [pagePathMixin],
  components: { InformationNotMaintained, TextNotMaintained, PriceMotMaintained, Completed },
  data() {
    return {
      activeName: 'InformationNotMaintained',
      tables: [
        {
          value: 'InformationNotMaintained',
          label: '基础信息未维护',
          number: '',
        },
        {
          value: 'TextNotMaintained',
          label: '产品文案未维护',
          number: '',
        },
        {
          value: 'PriceMotMaintained',
          label: '商品价格未维护',
          number: '',
        },
        {
          value: 'Completed',
          label: '已完成',
          number: '',
        },
      ],
    };
  },
  computed: {
    activeComponent() {
      return this.activeName;
    },
    query() {
      return this.$route.query;
    },
    permitList() {
      return JSON.parse(localStorage.getItem("permitList")) || []
    },
    isInformationNotMaintained() {
      return this.permitList.includes('ec-pc-new$productLifeCycle$aboutNew$ListingList$BasicInformationOperation')
    },
    isTextNotMaintained() {
      return this.permitList.includes('ec-pc-new$productLifeCycle$aboutNew$ListingList$ProductCopywritingOperation')
    },
    isPriceMotMaintained() {
      return this.permitList.includes('ec-pc-new$productLifeCycle$aboutNew$ListingList$CommodityPriceOperation')
    }
  },
  mounted() {
    this.getNumber()
    if (this.query.tabName) {
      this.activeName = this.query.tabName;
    }else if(this.isInformationNotMaintained) {
      this.activeName = 'InformationNotMaintained';
    }else if(this.isTextNotMaintained) {
      this.activeName = 'TextNotMaintained';
    }else if(this.isPriceMotMaintained) {
      this.activeName = 'PriceMotMaintained';
    }
  },
  methods: {
    getNumber() {
      const formData = new FormData();
      formData.append('listNo', this.query.listNo);
      this.$q.newProduct.productListStatics({ data: formData }).then((res) => {
        this.tables[0].number = res.data.baseQty
        this.tables[1].number = res.data.productQty
        this.tables[2].number = res.data.priceQty
        this.tables[3].number = res.data.finishedQty
        
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.panel-tabs
  >>> .main-area
    padding-top 0
.tabs
  >>> .el-tabs__header
    margin-bottom 5px
  >>> .el-badge
        left -4px
  >>> .el-badge__content
        background-color #f56c6c
</style>
